<template>
    <div>
        <input type="hidden" name="user_id" v-bind:value="user.id">
        <p class="use-filler_selected-user-name">{{ user.full_name }}</p>
    </div>
</template>

<script>
import {EventBus} from "../../EventBus";

export default {
        name: "UserFillerComponent",
        props: {
          placeholder: {
              type: String,
              default: 'Click edit to search for a user...',
          }
        },
        data: function() {
          return {
              user: {
                  full_name: ''
              }
          }
        },
        mounted() {
            this.user.full_name = this.placeholder;
            EventBus.on('user-selected', this.userSelected);
        },
        methods: {
            userSelected: function (user) {
                this.user = user;
            }
        }
    }
</script>

<style scoped>
    p {
        margin: 0px;
    }

    .use-filler_selected-user-name {
        line-height: 40px;
    }
</style>
